export const profilePicturesPath = 'placeholders/profile-picture.png';
export const personalAdvisorPicturesPath = 'placeholders/personal-advisor.jpeg';
